// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../../common/image.res.js");
var Dashboard$ReactHooksTemplate = require("../dashboard/dashboard.res.js");

function BreadCrumbsComponent(props) {
  var breadCrumbs = props.breadCrumbs;
  if (List.length(breadCrumbs) <= 1) {
    return JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  var breadCrumbsOnClick = props.breadCrumbsOnClick;
  return JsxRuntime.jsxs("div", {
              children: [
                $$Array.of_list(List.mapi((function (i, item) {
                            if (i < (List.length(breadCrumbs) - 1 | 0)) {
                              return JsxRuntime.jsx("button", {
                                          children: JsxRuntime.jsx("img", {
                                                src: Image$ReactHooksTemplate.backArrow
                                              }),
                                          className: "mr-4",
                                          onClick: (function (param) {
                                              Curry._2(breadCrumbsOnClick, item, i + 1 | 0);
                                            })
                                        });
                            } else {
                              return JsxRuntime.jsx(JsxRuntime.Fragment, {});
                            }
                          }), breadCrumbs)),
                $$Array.of_list(List.mapi((function (i, item) {
                            var dashboardName = Dashboard$ReactHooksTemplate.name(item);
                            if (i < (List.length(breadCrumbs) - 1 | 0)) {
                              return JsxRuntime.jsxs("span", {
                                          children: [
                                            JsxRuntime.jsx("button", {
                                                  children: dashboardName,
                                                  className: "text-aurometalsaurus text-16-px font-semibold",
                                                  onClick: (function (param) {
                                                      Curry._2(breadCrumbsOnClick, item, i + 1 | 0);
                                                    })
                                                }),
                                            JsxRuntime.jsx("span", {
                                                  children: " > ",
                                                  className: "ml-2 mr-3"
                                                })
                                          ],
                                          className: "py-2"
                                        }, String(i));
                            } else {
                              return JsxRuntime.jsx("span", {
                                          children: dashboardName,
                                          className: "text-16-px text-charcoal font-semibold py-2"
                                        }, String(i));
                            }
                          }), breadCrumbs))
              ],
              className: "flex"
            });
}

var make = BreadCrumbsComponent;

exports.make = make;
/* react/jsx-runtime Not a pure module */
